import styled, { css } from 'styled-components'
import { colors, sizes } from 'config/ui'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Wrapper = styled.div`
  ${({ width, secondary, fluid }) => css`
    width: ${width || '100%'};
    display: inline-block;
    ${secondary &&
    `
      ${
        !fluid &&
        css`
          max-width: 360px;
        `
      }
    `};
  `};
`

export const InputWrapper = styled.div`
  ${({
    error,
    success,
    disabled,
    focused,
    transparent,
    secondary,
    fluid
  }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: ${sizes.radius}px;
    border: 1px solid
      ${error
        ? colors.red
        : success
        ? '#58D68D'
        : focused
        ? colors.primary
        : secondary
        ? '#DFE5E9'
        : colors.border};
    background-color: ${disabled ? colors.lightGray : colors.white};

    ${secondary &&
    css`
      height: 46px;
      ${!fluid && 'max-width: 360px;'}
    `} ${transparent &&
    css`
      border: none;
    `};

    &:focus-within {
      border: 2px solid ${tokens.colors.primary900};
    }

    :focus-visible {
      outline: none;
    }
  `};
`

export const StyledInput = styled.input`
  ${({ height, transparent, disabled, secondary }) => css`
    ${height &&
    css`
      height: ${height}px;
    `} &:-moz-placeholder {
      color: ${secondary ? colors.gray7 : colors.gray};
    }
    &:-ms-input-placeholder {
      color: ${secondary ? colors.gray7 : colors.gray};
    }
    &::-moz-placeholder {
      color: ${secondary ? colors.gray7 : colors.gray};
    }
    &::-webkit-input-placeholder {
      color: ${secondary ? colors.gray7 : colors.gray};
    }
    font-size: ${sizes.paragraph}px;
    width: 100%;
    border: none;
    padding: 10px;
    height: 46px;
    background-color: transparent;

    ${secondary &&
    css`
      padding: 9px 10px 10px;
    `}
    :-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px white inset;
    }

    &:focus {
      outline: none;
      ${transparent &&
      css`
        border-bottom: 1px solid #dfe5e9;
      `};
    }

    ${disabled &&
    css`
      cursor: not-allowed;
    `};
  `};
`

export const Label = styled.label`
  ${({ disabled, color }) => css`
    display: block;
    margin-bottom: 4px;
    font-size: ${sizes.label}px;
    font-weight: 700;
    ${
      color
        ? css`
            color: ${color};
          `
        : css`
            color: ${colors.gray7};
          `
    }
    color: ${disabled && colors.gray}};
    cursor: pointer;
  `};
`

export const Helper = styled.div`
  display: block;
  margin-top: 10px;
  font-size: ${sizes.smallText}px;
  color: ${colors.gray};
`
